import { Avatar } from "@chakra-ui/react";
import { FC, ReactNode, useContext } from "react";
import Typhography from "../Typhography/Typhography";
import style from "./CustomAvatar.module.scss";
import classNames from "classnames";
import { AuthContext } from "../../providers/authProvider";
export const CustomAvatar: FC<{
  name?: string;
  src?: string;
  theme?: "secondary";
  className?: string;
  textClassName?: string;
  children?: ReactNode;
}> = ({ className = "", theme = "", name, src, children, textClassName }) => {
  return (
    <Avatar.Root
      className={classNames(style.container, className)}
      shape="rounded"
    >
      <Avatar.Fallback className={classNames(style.fallbackContainer, style[theme])}>
        {children || (
          <Typhography size="bold-14" className={classNames(textClassName)}>
            {name}
          </Typhography>
        )}
      </Avatar.Fallback>
      <Avatar.Image objectFit={"cover"} src={src} className={style.image} />
    </Avatar.Root>
  );
};

export default CustomAvatar;
